import React from 'react'
import SIZE from '../../../global/Size'
import styled from 'styled-components';

const ImageTitleTextCard = ({Image, Title, Text}) => {
  return (
    <OuterContainer>
      <StyledImage src={Image} />
      <TextContainer>
        <TitleText>{Title}</TitleText>
        <DescriptionText>{Text}</DescriptionText>
      </TextContainer>
    </OuterContainer>
  );
}

const OuterContainer = styled.div`
  width: auto;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-right: 10px;

  /* 450px 이상 800px 미만 */
    @media (min-width: 1px) and (max-width: 1400px) {
      align-items: flex-start;
  }
`;

const StyledImage = styled.img`
  width: 100%;
  height: 50%;
  object-fit: contain;
`;

const TextContainer = styled.div`
  width: auto;
  height: 50%;
  display: flex;
  flex-direction: column;

  /* 450px 이상 800px 미만 */
  @media (min-width: 1px) and (max-width: 1400px) {
    padding-bottom: 50px;
  }
`;

const TitleText = styled.p`
  font-size: ${props => props.theme.SIZE.LARGE};
  font-weight: 600;
`;

const DescriptionText = styled.span`
  line-height: 1.7;
`;


export default ImageTitleTextCard